import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'

// `GET /health/ready` ya existe (app/api/health.py) y no requiere sesión de Mini App — se
// reutiliza tal cual, sin ningún endpoint nuevo, para el punto de estado del header y el
// resumen de sistema del Home de administrador.
interface HealthReadyResponse {
  status: string
  timestamp: string
  active_leagues_count?: number
  fixtures_today_count?: number
  fixtures_analyzed_count?: number
  [engineFlag: string]: unknown
}

export function useSystemHealth(enabled: boolean) {
  return useQuery<HealthReadyResponse>({
    queryKey: ['mini-app', 'system-health'],
    queryFn: async () => (await apiClient.get('/health/ready')).data,
    enabled,
    staleTime: 60_000,
    retry: false,
  })
}
